import { Helmet } from "react-helmet-async";
import {
  getWhiteLabelBrand,
  WhiteLabelBrand
} from "../white-label-branding/getWhiteLabelBrand.tsx";

const getDocumentTitle = (brand?: WhiteLabelBrand) => {
  let documentTitleCompany = "";
  let documentTitleApp = ""; // TODO: Not implemented yet - TOL-866

  if (brand) documentTitleCompany = brand.title;

  const documentTitle = `${documentTitleCompany}${documentTitleApp && ` - ${documentTitleApp}`}`;
  return documentTitle;
};

const getFavIconHref = (brand?: WhiteLabelBrand) =>
  brand?.favIcon || "/favicon.ico";

export const HelmetDocumentManager = () => {
  const brand = getWhiteLabelBrand();

  const title = getDocumentTitle(brand);
  const favIconHref = getFavIconHref(brand);

  return (
    <Helmet>
      <title>{title}</title>
      <link id="favicon" rel="icon" href={favIconHref} type="image/x-icon" />
    </Helmet>
  );
};
